(function () {
    'use strict';

    angular.module("imApp").factory("stockCorrCodeService", ['$ihttp', function ($ihttp) {
        let service = {
            getStockCorrectionCode: function (parms) {
                return $ihttp.post({
                    method: 2483,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2484,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
